import request from '@/utils/request'


// 获取微信授权链接
export function getWxAuthUrl() {
    return request({
        url: '/h5/wechat/auth',
        method: 'get',
    })
}

// 获取微信JS签名
export function getJsapiSignature(url) {
    return request({
        url: '/h5/wechat/getJsapiSignature?url=' + url,
        method: 'get',
    })
}
